import { useState } from 'react';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { Input } from '@/components/ui/input';
import { Calendar } from '@/components/ui/calendar';
import dayjs, { Dayjs } from 'dayjs';
import { faCalendar } from '@fortawesome/pro-regular-svg-icons';

type DatePickerFieldProps = {
  date?: Dayjs | undefined;
  onSelect: (date: Date) => void;
};

function formatDate(date?: Date) {
  if (!date) return '';
  return dayjs(date).locale('de').format('dd., D. MMMM YYYY');
}

export default function DatePickerInput({
  date,
  onSelect,
}: DatePickerFieldProps) {
  const [open, setOpen] = useState(false);
  const defaultDate = (date ?? dayjs()).toDate();

  const handleSelect = (d: Date) => {
    setOpen(false);
    onSelect(d);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <div className="flex flex-col justify-between">
          <Input
            endIcon={faCalendar}
            className="cursor-pointer"
            value={formatDate(date?.toDate())}
            placeholder={'Datum auswählen'}
            readOnly
          />
        </div>
      </PopoverTrigger>
      <PopoverContent
        className="w-fit flex flex-col bg-white z-50"
        align="start">
        <Calendar
          mode="single"
          selected={defaultDate}
          onSelect={handleSelect}
          defaultMonth={date?.toDate()}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
